import { useIntl } from 'react-intl';

import { DownloadableCert } from '../DownloadableCert';
import type { DownloadProps } from '../DownloadableLimitededition';

import { ReactComponent as Jewelry } from '@/assets/icons/jewelry.svg';

import * as M from '../../messages';

export const DownloadableJewelry = ({ channel, sn }: DownloadProps) => {
  const { formatMessage } = useIntl();

  return (
    <DownloadableCert
      Svg={Jewelry}
      channel={channel}
      data-test-id='DownloadableJewelryCert'
      fileName='jewelry'
      sn={sn}
      text={formatMessage(M.messages.jewelryCertificate)}
    />
  );
};

DownloadableJewelry.displayName = 'DownloadableJewelry';
